/* eslint-disable @stylistic/brace-style */
import { optionsProxy } from '@vlabs/uikit';
import i18n from 'i18next';

export const CALLBACK_TYPE_OPTIONS = optionsProxy.create([
  { value: 'http', get label() { return i18n.t('constants:http'); } },
  { value: 'telegram', get label() { return i18n.t('constants:telegram'); } },
]);
